import * as React from "react"

const Icon = (props) => 
   (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20.265}
      height={15}
      {...props}
    >
      <defs>
        <style>{".prefix__cls-1{fill:#2d5d7c}"}</style>
      </defs>
      <g
        id="prefix__Group_70"
        data-name="Group 70"
        transform="translate(1793.73 3647)"
      >
        <path
          id="prefix__Path_40"
          data-name="Path 40"
          className="prefix__cls-1"
          d="M6.267 19.42h16.27a1.891 1.891 0 002-1.75 1.891 1.891 0 00-2-1.75H6.267a1.892 1.892 0 00-2 1.75 1.892 1.892 0 002 1.75z"
          transform="translate(-1798 -3662.921)"
          
        />
        <path
          id="prefix__Path_41"
          data-name="Path 41"
          className="prefix__cls-1"
          d="M22.538 78.08H6.267a1.765 1.765 0 100 3.5h16.27a1.765 1.765 0 100-3.5z"
          transform="translate(-1798 -3713.579)"
        />
        <path
          id="prefix__Path_42"
          data-name="Path 42"
          className="prefix__cls-1"
          d="M22.538 47H6.267a1.765 1.765 0 100 3.5h16.27a1.765 1.765 0 100-3.5z"
          transform="translate(-1798 -3688.25)"
        />
      </g>
    </svg>
  )


export default Icon